import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";

export const SidebarSkeleton = ({ iconColor }) => {
    const themeMode = useSelector(state => state.themeMode?.themeMode || 'light');

    return (
        <SkeletonTheme
            baseColor={themeMode === 'dark' ? "#2a2a2a" : "#e5e7eb"}
            highlightColor={themeMode === 'dark' ? "#3a3a3a" : "#f3f4f6"}
        >
            <div className="tab-pane fade active show">
                <ul className={`list-unstyled mb-4 menu-list ${iconColor}`}>

                    {/* single menu items */}
                    {[1, 2, 3, 4].map((_, i) => (
                        <li key={i} className="d-flex align-items-center px-3 py-2">
                            <Skeleton circle height={24} width={24} />
                            <span className="flex-fill">
                                <Skeleton height={16} width="100%" className="ms-2 mt-1" />
                            </span>
                        </li>
                    ))}

                    {/* grouped / dropdown items */}
                    {Array.from({ length: 4 }).map((_, index) => (
                        <li key={index} className="d-flex align-items-start px-3 py-2">
                            <Skeleton circle height={24} width={24} />
                            <span className="flex-fill">
                                {Array.from({ length: 6 }).map((__, i) => (
                                    <Skeleton
                                        key={i}
                                        height={16}
                                        width="100%"
                                        className="ms-2 mb-1"
                                    />
                                ))}
                            </span>
                        </li>
                    ))}

                </ul>
            </div>
        </SkeletonTheme>
    );
};
